import React from "react";
import momoimage from "../assets/images/momos-img.webp";


export default function CTASection({ setPage }) {
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <div className="cta-content">
          <h2 className="cta-title">READY FOR THE MILLET REVOLUTION?</h2>
          <p className="cta-text">Order your healthy, delicious millet momos today. Experience guilt-free indulgence!</p>
          <a href="mailto:hello@milletmomos.com" className="cta-btn">Order Now →</a>
        </div>
        <div className="cta-visual">
          <img src={momoimage} className="cta-img"  alt="Healthy millet momos"  width="600"  height="400" loading="lazy" />
        </div>
      </div>
    </section>
  );
}